<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title | translate"
    [isForm]="true"
    (onBack)="onClose()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <div class="app-page-content">
    <!-- content -->
    <div class="app-page-content">
      <div class="row tw-justify-center tw-px-6">
        <!-- col 1  -->
        <div class="md:tw-w-7/12 p-0">
          <ul class="list-group">
            <list-group-item
              [label]="'common.name' | translate"
              [value]="model?.resellerName"
            >
            </list-group-item>

            <!-- desktop -->

            <list-group-item
              [label]="fields + 'desktop' | translate"
              [value]="DesktopEnumDisplay[model?.desktop] | translate"
            >
            </list-group-item>

            <!-- resellerDomain -->

            <list-group-item
              [label]="fields + 'resellerDomain' | translate"
              [value]="model?.resellerDomain"
            >
            </list-group-item>

            <!-- identityDomain -->

            <list-group-item
              [label]="fields + 'resellerIdentityDomain' | translate"
              [value]="model?.resellerIdentityDomain"
            >
            </list-group-item>

            <!-- link -->

            <list-group-item
              [label]="fields + 'resellerLink' | translate"
              [value]="model?.resellerLink"
            >
            </list-group-item>

            <!-- created -->
            <list-group-item
              [label]="'common.createDate' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <span class="dir-ltr">
                  {{
                    model?.created
                      | dateTimeConvertor : translationService.currentLang()
                      | checkValue
                  }}
                </span>
              </div>
            </list-group-item>

            <!-- lastModified -->

            <list-group-item
              [label]="'common.lastModifiedDate' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <span class="dir-ltr">
                  {{
                    model?.lastModified
                      | dateTimeConvertor : translationService.currentLang()
                      | checkValue
                  }}
                </span>
              </div>
            </list-group-item>
          </ul>
        </div>
        <!-- col 2  -->
        <div class="md:tw-w-5/12 tw-flex-center p-0">
          <div class="tw-flex-center flex-column">
            <span class="tw-font-bold tw-mb-2 text-zinc"
              >{{ fields + "agentLogo" | translate }} :</span
            >
            <app-show-images
              [src]="imagePath"
              imgStyle="padding:20px"
              imgHeight="250px"
              imgWidth="250px"
            >
            </app-show-images>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-page-body>
